<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="primary">
      <ion-button (click)="modalController.dismiss()"> {{ 'core.done' | translate }} </ion-button>
    </ion-buttons>

    <ion-title>{{ 'settings.information.licenses.licensesTitle' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list>
    <ion-list-header lines="inset">
      <ion-label>{{ 'settings.information.licenses.npmTitle' | translate }}</ion-label>
    </ion-list-header>
    @for (license of LICENSES; track license) {
      <ion-item (click)="openLicense(license)" detail="true">
        <ion-label>
          <p class="note ion-text-wrap">
            {{ license.group }}
          </p>
          <ion-text class="ion-text-wrap">
            {{ license.artifact }}
          </ion-text>
          <p class="ion-text-wrap">
            {{ license.description }}
          </p>
          <p class="ion-text-wrap">
            <strong>
              {{ 'settings.information.licenses.licensedBy' | translate }} {{ licenseList(license.licenses) }}
            </strong>
          </p>
        </ion-label>
      </ion-item>
    }
  </ion-list>

  <ion-list>
    <ion-list-header lines="inset">
      <ion-label>{{ 'settings.information.licenses.androidTitle' | translate }}</ion-label>
    </ion-list-header>
    @for (license of GRADLE_LICENSES; track license) {
      <ion-item (click)="openLicense(license)" detail="true">
        <ion-label>
          <p class="note ion-text-wrap">
            {{ license.group }}
          </p>
          <ion-text class="ion-text-wrap">
            {{ license.artifact }}
          </ion-text>
          <p class="ion-text-wrap">
            {{ license.description }}
          </p>
          <p class="ion-text-wrap">
            <strong>
              {{ 'settings.information.licenses.licensedBy' | translate }} {{ licenseList(license.licenses) }}
            </strong>
          </p>
        </ion-label>
      </ion-item>
    }
  </ion-list>

  <ion-list>
    <ion-list-header lines="inset">
      <ion-label>{{ 'settings.information.licenses.iOSTitle' | translate }}</ion-label>
    </ion-list-header>
    @for (license of COCOAPODS_LICENSES; track license) {
      <ion-item (click)="openLicense(license)" detail="true">
        <ion-label>
          <p class="note ion-text-wrap">
            {{ license.group }}
          </p>
          <ion-text class="ion-text-wrap">
            {{ license.artifact }}
          </ion-text>
          <p class="ion-text-wrap">
            {{ license.description }}
          </p>
          <p class="ion-text-wrap">
            <strong>
              {{ 'settings.information.licenses.licensedBy' | translate }} {{ licenseList(license.licenses) }}
            </strong>
          </p>
        </ion-label>
      </ion-item>
    }
  </ion-list>
</ion-content>
